import { Component, OnInit } from '@angular/core';
import { OrderService } from '../../services/order/order.service';
import { Chart } from 'chart.js';
import 'chart.piecelabel.js';
import { ResourceService } from 'src/app/services/resource/resource.service';
import { DatePipe } from '@angular/common';
import { TokenStorage } from '../../auth/token.storage';
import { database } from 'firebase';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  columnsToDisplay = ["zone", "ordercount"]
  threeMonthsOrderCountData = [];
  displayedColumns: string[] = ['position', 'name', 'weight', 'symbol'];
  orderLineChart: Chart;
  fleetBarChart = [];
  donutZone = [];
  totaldeliveredcount: number = 0;
  totalundeliveredcount: number = 0;
  allBranches = [];
  fromDate: any;
  toDate: any;
  threeMonthsName = [];
  monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  isTenantDiag: boolean = false;
  oTypes;

  constructor(
    public orderService: OrderService,
    public resourceService: ResourceService,
    private datePipe: DatePipe,
    private token: TokenStorage
  ) {
  }

  ngOnInit() {
    let date, last, day, month, year;
    date = new Date();
    //365 is num of days
    last = new Date(date.getTime() - (365 * 24 * 60 * 60 * 1000));
    day = last.getDate();
    month = last.getMonth();
    year = last.getFullYear();
    this.fromDate = this.datePipe.transform(new Date(year, month, day), 'yyyy-MM-dd');
    this.toDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');

    if (this.token.getCustomerType() === 'Diagnostic') {
      this.isTenantDiag = true;
      this.oTypes = ['ORDER_TYPE_PICKUP', 'ORDER_TYPE_MARKETING_VISIT', 'ORDER_TYPE_HOME_COLLECTION'];
      this.lineOrderChart('sample');
    } else {
      this.isTenantDiag = false;
      this.oTypes = ['ORDER_TYPE_DELIVERY'];
      this.lineOrderChart(null);
    }

    this.getOrderCountThreeMonths(new Date().getMonth(), new Date().getFullYear());

    this.orderService.getOrderCountByStatus(this.fromDate, this.toDate, this.oTypes).subscribe(res => {
      let del = res.find(d => d.orderstatus === 'ORDER_STATE_DELIVERED');
      if (del)
        this.totaldeliveredcount = del.ordercount;
      let undel = res.find(d => d.orderstatus === 'ORDER_STATE_FAILED');
      if (undel)
        this.totalundeliveredcount = undel.ordercount;
    });

    this.barfleetChart();
    this.doghnutForDeliveredAndUndeliveredOrders();

  }

  getOrderCountThreeMonths(month, year) {
    this.orderService.getOrderCountByStatus(this.datePipe.transform(new Date(year, month - 1, 1), 'yyyy-MM-dd'), this.datePipe.transform(new Date(year, month, 0), 'yyyy-MM-dd'), this.oTypes).subscribe(month1 => {
      this.orderService.getOrderCountByStatus(this.datePipe.transform(new Date(year, month - 2, 1), 'yyyy-MM-dd'), this.datePipe.transform(new Date(year, month - 1, 0), 'yyyy-MM-dd'), this.oTypes).subscribe(month2 => {
        this.orderService.getOrderCountByStatus(this.datePipe.transform(new Date(year, month - 3, 1), 'yyyy-MM-dd'), this.datePipe.transform(new Date(year, month - 2, 0), 'yyyy-MM-dd'), this.oTypes).subscribe(month3 => {
          let countsData = [];
          countsData.push(month1);
          countsData.push(month2);
          countsData.push(month3);
          if (this.isTenantDiag) {
            let pickupData = [
              {
                monthName: this.monthNames[(month - 1 + 12) % this.monthNames.length],
                column1: 0,
                column2: 0,
                column3: 0
              },
              {
                monthName: this.monthNames[(month - 2 + 12) % this.monthNames.length],
                column1: 0,
                column2: 0,
                column3: 0
              },
              {
                monthName: this.monthNames[(month - 3 + 12) % this.monthNames.length],
                column1: 0,
                column2: 0,
                column3: 0
              }
            ];
            let homeCollectionData = [
              {
                monthName: this.monthNames[(month - 1 + 12) % this.monthNames.length],
                column1: 0,
                column2: 0,
                column3: 0
              },
              {
                monthName: this.monthNames[(month - 2 + 12) % this.monthNames.length],
                column1: 0,
                column2: 0,
                column3: 0
              },
              {
                monthName: this.monthNames[(month - 3 + 12) % this.monthNames.length],
                column1: 0,
                column2: 0,
                column3: 0
              }
            ];
            let fieldVisitData = [
              {
                monthName: this.monthNames[(month - 1 + 12) % this.monthNames.length],
                column1: 0,
                column2: 0,
                column3: 0
              },
              {
                monthName: this.monthNames[(month - 2 + 12) % this.monthNames.length],
                column1: 0,
                column2: 0,
                column3: 0
              },
              {
                monthName: this.monthNames[(month - 3 + 12) % this.monthNames.length],
                column1: 0,
                column2: 0,
                column3: 0
              }
            ];

            for (let i = 0; i < countsData.length; i++) {
              pickupData[i].column1 = countsData[i].find(obj => { return obj['orderstatus'] == 'ORDER_STATE_DELIVERED' && obj['order_type'] == 'ORDER_TYPE_PICKUP'; });
              pickupData[i].column2 = countsData[i].find(obj => { return obj['orderstatus'] == 'ORDER_STATE_FAILED' && obj['order_type'] == 'ORDER_TYPE_PICKUP'; });
              pickupData[i].column3 = countsData[i].find(obj => { return obj['orderstatus'] == 'ORDER_STATE_IN_TRANSIT' && obj['order_type'] == 'ORDER_TYPE_PICKUP'; });

              homeCollectionData[i].column1 = countsData[i].find(obj => { return obj['orderstatus'] == 'ORDER_STATE_DELIVERED' && obj['order_type'] == 'ORDER_TYPE_HOME_COLLECTION'; });
              homeCollectionData[i].column2 = countsData[i].find(obj => { return obj['orderstatus'] == 'ORDER_STATE_FAILED' && obj['order_type'] == 'ORDER_TYPE_HOME_COLLECTION'; });
              homeCollectionData[i].column3 = countsData[i].find(obj => { obj['orderstatus'] == 'ORDER_STATE_IN_TRANSIT' && obj['order_type'] == 'ORDER_TYPE_HOME_COLLECTION'; });

              fieldVisitData[i].column1 = countsData[i].find(obj => { return obj['orderstatus'] == 'ORDER_STATE_DELIVERED' && obj['order_type'] == 'ORDER_TYPE_MARKETING_VISIT'; });
              fieldVisitData[i].column2 = countsData[i].find(obj => { return obj['orderstatus'] == 'ORDER_STATE_FAILED' && obj['order_type'] == 'ORDER_TYPE_MARKETING_VISIT'; });
              fieldVisitData[i].column3 = countsData[i].find(obj => { return obj['orderstatus'] == 'ORDER_STATE_IN_TRANSIT' && obj['order_type'] == 'ORDER_TYPE_MARKETING_VISIT'; });
            }

            this.threeMonthsOrderCountData.push(pickupData);
            this.threeMonthsOrderCountData.push(fieldVisitData);
            this.threeMonthsOrderCountData.push(homeCollectionData);
          } else {
            let data = [
              {
                monthName: this.monthNames[(month - 1 + 12) % this.monthNames.length],
                column1: 0,
                column2: 0,
                column3: 0
              },
              {
                monthName: this.monthNames[(month - 2 + 12) % this.monthNames.length],
                column1: 0,
                column2: 0,
                column3: 0
              },
              {
                monthName: this.monthNames[(month - 3 + 12) % this.monthNames.length],
                column1: 0,
                column2: 0,
                column3: 0
              }
            ]

            data[0].column1 = this.searchArraryForCount(countsData[0], 'ORDER_STATE_DELIVERED')
            data[0].column2 = this.searchArraryForCount(countsData[0], 'ORDER_STATE_FAILED')
            data[0].column3 = this.searchArraryForCount(countsData[0], 'ORDER_STATE_IN_TRANSIT')
            data[1].column1 = this.searchArraryForCount(countsData[1], 'ORDER_STATE_DELIVERED')
            data[1].column2 = this.searchArraryForCount(countsData[1], 'ORDER_STATE_FAILED')
            data[1].column3 = this.searchArraryForCount(countsData[1], 'ORDER_STATE_IN_TRANSIT')
            data[2].column1 = this.searchArraryForCount(countsData[2], 'ORDER_STATE_DELIVERED')
            data[2].column2 = this.searchArraryForCount(countsData[2], 'ORDER_STATE_FAILED')
            data[2].column3 = this.searchArraryForCount(countsData[2], 'ORDER_STATE_IN_TRANSIT')
            this.threeMonthsOrderCountData.push(data[0]);
            this.threeMonthsOrderCountData.push(data[1]);
            this.threeMonthsOrderCountData.push(data[2]);
            console.log(this.threeMonthsOrderCountData)
          }
        });
      });
    });
  }

  barfleetChart() {
    this.orderService.getChartFleet().subscribe(res => {
      let j;
      //this loop is to find delivered and undelivered data for each fleet
      let deliveredData = [], undeliveredData = [], driverArray = [];
      for (j in res) {
        if (res[j].orderstatus == "ORDER_STATE_DELIVERED") {
          if (!driverArray) {
            driverArray.push(res[j].delivery_boy);
          }
          else if (driverArray.includes(res[j].delivery_boy)) {
            let index = driverArray.indexOf(res[j].delivery_boy);
            //undeliveredData[index] = res[j].totalcount;
          }
          else {
            driverArray.push(res[j].delivery_boy);
            //undeliveredData.push(0);
          }

          deliveredData.push(res[j].totalcount);
        }
        else {
          if (!driverArray) {
            driverArray.push(res[j].delivery_boy);
          }
          else if (driverArray.includes(res[j].delivery_boy)) {
            let index = driverArray.indexOf(res[j].delivery_boy);
            //deliveredData[index] = res[j].totalcount;
          }
          else {
            driverArray.push(res[j].delivery_boy);
            //deliveredData.push(0);
          }

          undeliveredData.push(res[j].totalcount);
        }
      }

      let colorsDelivered = [], colorsUnDelivered = [], i;
      colorsDelivered = Array(driverArray.length).fill('blue');
      colorsUnDelivered = Array(driverArray.length).fill('red');

      let fleetBarChartDeliveredString = ""
      let fleetBarChartUndeliveredString = ""
      if (this.isTenantDiag) {
        fleetBarChartDeliveredString = "Picked"
        fleetBarChartUndeliveredString = "Not Picked"
      }
      else {
        fleetBarChartDeliveredString = "Delivered"
        fleetBarChartUndeliveredString = "Undelivered"
      }

      this.fleetBarChart = new Chart('canvasbar', {
        type: "bar",
        "data": {
          "labels": driverArray,
          "datasets": [{
            "label": fleetBarChartDeliveredString,
            "data": deliveredData,
            "backgroundColor": '#007bff',
            "borderWidth": 1,
          }, {
            "label": fleetBarChartUndeliveredString,
            "data": undeliveredData,
            "backgroundColor": '#f27173',
            "borderWidth": 1,
          }]
        },

        options: {
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true,
                userCallback: function (label, index, labels) {
                  if (Math.floor(label) === label) {
                    return label;
                  }
                }
              },
              gridLines: {
                display: false
              }
            }],
            xAxes: [{
              ticks: {
                autoSkip: false,
                fontSize: 13
              },
              gridLines: {
                offsetGridLines: true
              }
            }]
          },
          tooltips: {
            enabled: true,
            mode: 'index'
          },
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: true
          }
        }
      })
    })
  }

  getRandomColor() {
    var color = Math.floor(0x1000000 * Math.random()).toString(16);
    return '#' + ("000000" + color).slice(-6);
  }


  doghnutForDeliveredAndUndeliveredOrders() {
    let date, last, day, month, year;
    date = new Date();
    last = new Date(date.getTime() - (90 * 24 * 60 * 60 * 1000));
    day = last.getDate();
    month = last.getMonth();
    year = last.getFullYear();
    let orderStates = ['ORDER_STATE_UNPLANNED', 'ORDER_STATE_IN_PLANNING', 'ORDER_STATE_SCHEDULED', 'ORDER_STATE_IN_TRANSIT', 'ORDER_STATE_FAILED', 'ORDER_STATE_DELIVERED']

    this.orderService.getOrderReportByStates(this.datePipe.transform(new Date(year, month, day), 'yyyy-MM-dd'), this.datePipe.transform(new Date(), 'yyyy-MM-dd'), orderStates).subscribe(res => {
      this.resourceService.getBranches().subscribe(allbranches => {
        this.allBranches = allbranches;

        let delivereddonut = [], undelivereddonut = [];
        allbranches.forEach(branch => {
          let unplannedOrdersByBranch = [], deliveredOrderByBranch = [], undeliveredOrderByBranch = [];
          unplannedOrdersByBranch = res.filter(order => order.wareHouse == branch.branchName && order.orderstatus == 'ORDER_STATE_UNPLANNED');
          deliveredOrderByBranch = res.filter(order => order.wareHouse == branch.branchName && order.orderstatus == 'ORDER_STATE_DELIVERED');
          //if (deliveredOrderByBranch.length > 0)
          delivereddonut.push(deliveredOrderByBranch);
          undeliveredOrderByBranch = res.filter(order => order.wareHouse == branch.branchName && order.orderstatus == 'ORDER_STATE_FAILED');
          //if (undeliveredOrderByBranch.length > 0)
          undelivereddonut.push(undeliveredOrderByBranch);
        });
        this.drawPieChart(delivereddonut, 'delivered');
        this.drawPieChart(undelivereddonut, 'undelivered');
      });
    })
  }


  drawPieChart(donutData, canvasname) {
    let zoneData = [];
    let zoneNames = [];
    let colors = [], count = {}, i = 0, j;

    donutData.forEach(data => {
      count[i] = data.length;
      i++;
    });

    this.allBranches.forEach(branch => {
      zoneNames.push(branch.branchName);
    });

    for (j in count) {
      zoneData.push(JSON.stringify(count[j]));
      colors.push(this.getRandomColor());
    }
    this.donutZone = new Chart(canvasname, {

      type: "doughnut",
      "data": {
        "labels": zoneNames,
        "datasets": [{
          "data": zoneData,
          "fill": false,
          "backgroundColor": colors,
          "borderColor": ["white"],
          "borderWidth": 1
        }]
      },
      options: {

        pieceLabel: {
          render: function (args) {
            const value = args.value;
            return value;
          },
          fontColor: "white",
          fontSize: 10,
        },
        legend: {
          display: false,
          position: 'bottom'
        }
      }
    })
  }

  lineOrderChart(trendType: string) {
    let label = '# of Orders';
    if (this.orderLineChart) {
      this.orderLineChart.reset();
    }
    let orderTypes = ['ORDER_TYPE_DELIVERY'];
    if (this.isTenantDiag) {
      if (trendType == 'sample' || trendType == 'home') {
        label = "# of Pickup's";
        orderTypes = ['ORDER_TYPE_PICKUP'];
      } else if (trendType == 'field') {
        label = "# of Visits";
        orderTypes = ['ORDER_TYPE_MARKETING_VISIT'];
      }
    }
    this.orderService.getChartData(orderTypes).subscribe(res => {
      let deliveredcount = res.map(res => res.deliveredcount);
      let undeliveredcount = res.map(res => res.undeliveredcount);
      let alldates = res.map(res => res.dateforDisplay);

      let lineOrderChartDeliveredString = ""
      let lineOrderChartUndeliveredString = ""
      if (this.isTenantDiag) {
        if (trendType == 'sample' || trendType == 'home') {
          lineOrderChartDeliveredString = "Picked";
          lineOrderChartUndeliveredString = "Not Picked";
        } else {
          lineOrderChartDeliveredString = "Visited";
          lineOrderChartUndeliveredString = "Not Visited";
        }
      }
      else {
        lineOrderChartDeliveredString = "Delivered"
        lineOrderChartUndeliveredString = "Undelivered"
      }

      this.orderLineChart = new Chart('canvasLine', {
        type: 'line',
        data: {
          labels: alldates,
          datasets: [
            {
              label: lineOrderChartDeliveredString,
              data: deliveredcount,
              fill: true,
              pointHoverBackgroundColor: "#36A2EB",
              pointHoverBorderColor: "#36a2eb05",
              pointBorderWidth: 1,
              borderWidth: 2,
              backgroundColor: '#36a2eb05',
              borderColor: '#36A2EB',
              pointBorderColor: '#36A2EB05',
              pointBackgroundColor: '#36a2eb',
            },
            {
              label: lineOrderChartUndeliveredString,
              data: undeliveredcount,
              fill: true,
              pointHoverBackgroundColor: "#f27173",
              pointHoverBorderColor: "#f2717305",
              pointBorderWidth: 1,
              borderWidth: 2,
              backgroundColor: '#f2717305',
              borderColor: '#f27173',
              pointBorderColor: '#f2717305',
              pointBackgroundColor: '#f27173',
            }
          ]
        },
        options: {
          maintainAspectRatio: false,
          responsive: true,
          legend: {
            display: true
          },
          tooltips: {
            mode: 'index'
          },
          scales: {
            xAxes: [{
              display: true,
              scaleLabel: {
                display: true,
                labelString: 'Date',
                fontSize: 15,
                fontColor: "black"
              },
              gridLines: {
                display: false
              }
            }],
            yAxes: [{
              display: true,
              scaleLabel: {
                display: true,
                labelString: label,
                fontSize: 15,
                fontColor: "black"
              },
              ticks: {
                beginAtZero: true,
                userCallback: function (label, index, labels) {
                  if (Math.floor(label) === label) {
                    return label;
                  }
                },
              },
              gridLines: {
                display: false
              }
            }]
          }
        }
      });
    })
  }

  onTrendChange(trendType: string) {
    this.lineOrderChart(trendType);
  }

  searchArraryForCount(arr, value) {
    console.log(arr)
    let count = 0;
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].orderstatus === value) {
        count = count + arr[i].ordercount;
      }
    }
    return count;
  }
}
